import { render, staticRenderFns } from "./ServiceCards.vue?vue&type=template&id=2f23147a&"
import script from "./ServiceCards.vue?vue&type=script&lang=js&"
export * from "./ServiceCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports